/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, borderRadius } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Warning = styled.div`
  border-radius: ${borderRadius()}px;
  border: 1px solid ${token('color.border.warning', colors.Y100)};
  background: ${token('color.background.warning', colors.Y50)};
  padding: ${token('space.200')};
  display: flex;
  min-width: 392px;
  max-width: 636px;
`;

export const Header = styled.div`
  font: ${token('font.heading.xsmall')};
  margin: ${token('space.050')} 0 ${token('space.100')};
`;

export const WarningIcon = styled.span`
  align-self: flex-start;
  color: ${token('color.icon.warning', colors.Y300)};
  display: flex;
  flex-shrink: 0;
  margin-right: ${token('space.200')};
`;
